<template>
	<div>
		<div>
			<div style="background-color: #4db156; color: white; padding: 8px" >
				<b>
					Nowa wersja:
				</b>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "NewVersionMarker"
	};
</script>

<style scoped>

</style>